export const environment = {
  production: true,
  webservice: {
    baseurl: 'https://admin.jjensen.staging.side-walk.dk/api/v1/driver/',
  },
};
